<template>
    <div class="">
        <wiki-main-page-header
                v-if="membershipLoaded"
                :show-back-button="showBackButton"
                @goToManageAccess="goToManageAccess"
                @goBack="goBack"
        >
                <span style="" class="wiki-header-label" v-if="isMainSectionOpened">{{ wikiName |cutName(30) }} <i
                        class="fa fa-pencil pointer" v-if="isEditable&&editMode" @click="editWiki"></i></span>
            <wiki-breadcrumbs
                    v-else
                    @mainSectionClick="onMainSectionOpen"
                    @sectionClick="onSectionOpen"
                    :section="currentSection"
                    :wikiOwner="wikiOwner"
            ></wiki-breadcrumbs>
        </wiki-main-page-header>
        <wiki-read-receipt-page-navigation
                v-if="readReceiptMode&&membershipLoaded&&membershipAccessGranted"
                class="margin-15-top margin-10-bottom"
                @onSectionOpen="onSectionOpen"
                @onSlideOpen="onSlideOpen"
                @onMainSectionOpen="onMainSectionOpen"
        ></wiki-read-receipt-page-navigation>
        <wiki-page-abstract
                :wiki-id="wikiId"
                :key="wikiId"
                :access-code="accessCode"
                :getSectionLink="getSectionLink"
                @onSectionOpen="onSectionOpen"
                @goBack="goBack"
                @onMainSectionOpen="onMainSectionOpen"
        >
        </wiki-page-abstract>
    </div>

</template>

<script>
    import Vue from 'vue';
    import { DjangoUrls } from 'DjangoUrls';
    import WikiPageAbstract from './WikiPageAbstract';
    import WikiMainPageHeader from './WikiMainPageHeader';
    import WikiBreadcrumbs from '../wiki/wiki_breadcrumbs/WikiBreadcrumbs';
    import { mapGetters } from 'vuex';
    import { ROUTER_NAME_PREFIX } from './config';
    import {
        getMainWikiPageName,
        getSubsectionDetailWikiPageName,
        getSubsectionWikiPageName
    } from './WikiChildrenPages';
    import { CurrentUserClass } from 'shared/CurrentUser';
    import BackButtonMixin from '../../../vue/mixins/BackButtonMixin';
    import WikiReadReceiptPageNavigation from '../wiki/wiki_read_receipts_common/WikiReadReceiptPageNavigation';

    export default {
        name: 'WikiPageInMyStuff',
        components: {
            WikiReadReceiptPageNavigation,
            WikiPageAbstract,
            WikiMainPageHeader,
            WikiBreadcrumbs
        },
        mixins: [BackButtonMixin],
        props: {
            wikiId: {
                type: [String, Number],
            },
            accessCode: {
                type: String,
                required: false
            }
        },
        computed: {
            ...mapGetters('WikiStore', ['membershipAccessGranted', 'membershipLoaded', 'currentSection', 'wikiOwner', 'wikiName', 'isEditable', 'isMainSectionOpened', 'editMode', 'readReceiptMode', 'readReceipt', 'activeSlide']),
            showBackButton () {
                return !this.isMainSectionOpened || !!this.$route.query['fl'];
            },
            isMyWiki () {
                if (!this.membershipLoaded||!this.membershipAccessGranted) {
                    return false;
                }
                return new CurrentUserClass().id === this.wikiOwner.id;
            },
        },
        methods: {
            editWiki () {
                this.$store.dispatch('WikiStore/editWiki')
                  .then(actionDone => {
                      if (actionDone === 'deleted') {
                          if (this.$route.query.fl) {
                              this.$router.push({ name: 'WikisSharedList' });
                          } else {
                              this.$router.push({ name: 'WikisSharedList' }); // empty Wiki Page;
                          }
                      }
                  });
            },
            getSectionLink (section, slide = undefined) {
                const params = {
                    sectionId: section.id,
                    wikiId: this.wikiId,
                    accessCode: this.accessCode,
                };
                if (slide) {
                    params.slideId = slide.id;
                }
                if (section.is_submenu) {
                    return {
                        name: getSubsectionWikiPageName(ROUTER_NAME_PREFIX),
                        params,
                        query: this.$route.query
                    };
                } else {
                    return {
                        name: getSubsectionDetailWikiPageName(ROUTER_NAME_PREFIX),
                        params,
                        query: this.$route.query
                    };
                }
            },
            onSectionOpen (section) {
                if (section.id === this.currentSection?.id) {
                    return;
                }
                this.$router.push(this.getSectionLink(section));
            },
            onSlideOpen ({
                section,
                slide
            }) {
                if (slide.id === this.activeSlide?.id) {
                    return;
                }
                this.$router.push(this.getSectionLink(section, slide));
            },
            goBack () {
                // if(window.history&&window.history.length){
                //             window.history.back();
                //             return;
                //         }
                if (this.urlFrom) {
                    this.$_goBack();
                    return;
                }
                if (this.currentSection) {
                    if (this.currentSection.parent_section) {
                        this.$router.push({
                            name: getSubsectionWikiPageName(ROUTER_NAME_PREFIX),
                            params: {
                                sectionId: this.currentSection.parent_section.id,
                                accessCode: this.accessCode
                            },
                            query: this.$route.query
                        });
                    } else {
                        this.$router.push({
                            name: getMainWikiPageName(ROUTER_NAME_PREFIX),
                            params: {
                                wikiId: this.wikiId,
                                accessCode: this.accessCode
                            },
                            query: this.$route.query
                        });
                    }
                } else {
                    if (this.$route.query['fl']) {
                        const $rootScope = Vue.getAngularModule('$rootScope');
                        $rootScope.show_dimmer();
                        this.$router.push({ name: 'WikisSharedList' });
                    }
                }
            },
            onMainSectionOpen () {
                this.$router.push({
                    name: getMainWikiPageName(ROUTER_NAME_PREFIX),
                    params: {
                        wikiId: this.wikiId,
                        accessCode: this.accessCode
                    },
                    query: this.$route.query
                });
            },
            goToManageAccess () {
                this.$router.push({
                    name: 'MainWikiPageManageAccess',
                    params: { wikiId: this.wikiId }
                });
            },
            async loadReadReceiptIfRequired () {
                const receiptCode = this.$route.query?.rr;
                if (receiptCode) {
                    await this.$store.dispatch('WikiStore/loadReadReceipt', receiptCode);
                }
            },
            // newWikiCreated(wikiId) {
            //     this.$router.push({
            //         name: getMainWikiPageName(ROUTER_NAME_PREFIX),
            //         params: {
            //             wikiId,
            //             accessCode: this.accessCode
            //         },
            //         query: this.$route.query
            //     });
            // },
            goToAccessErrorPage () {
                this.$router.replace({
                    name: 'WikiAccessErrorPage',
                    params: { wikiId: this.wikiId }
                });
            }
        },
        mounted () {
            this.loadReadReceiptIfRequired();
        },
        watch: {
            wikiId (n) {
                console.log(n);
                this.$store.commit('WikiStore/resetLoadedState');
                // this.$store.commit('WikiStore/setAccessParams', {wikiId: this.wikiId, accessCode: this.accessCode});
            }
        },
        metaInfo () {
            let title = 'Wiki';
            if (this.isMyWiki) {
                title = 'My Wiki';
            }
            if (this.wikiName) {
                if (this.isMyWiki) {
                    title = `My Wiki - ${this.wikiName}`;
                } else {
                    title = `${this.wikiName} - Wiki`;
                }
            }
            return {
                title
            };
        }
    };
</script>

<style scoped lang="scss">
  @import "../styles/const";

  .wiki-header-label {
    font-weight: bolder;
    font-size: 22px;
    @media (max-width: $screen-xs-max) {
      font-size: 19px;
    }
    @media (min-width: $screen-sm-min) {
      font-size: 21px;
      line-height: 58px;
    }
  }
</style>
